import React from 'react';
import clsx from 'clsx';

import css from './ProgressBar.module.scss';

interface Props {
    isCompleted?: boolean;
}

const ProgressBar: React.FC<Props> = ({ isCompleted = false }) => (
    <div className={css.container}>
        <div className={clsx(css.bar, isCompleted && css.iscompleted)} />
    </div>
);

export default React.memo(ProgressBar);
